import React from "react";
import { t } from "../i18n";

const Footer = ({ theme = "light", language = "en" }) => {
  const messages = t(language);
  const isDark = theme === "dark";

  const containerStyle = {
    backgroundColor: isDark ? "#0b0e12" : "#f9f9f9",
    color: isDark ? "#dbe3ee" : "#4b5563",
    textAlign: "center",
    padding: "6px 4px",        // smaller padding
    fontSize: "0.75rem",       // compact text size
    borderTop: isDark ? "1px solid #3a3f47" : "1px solid #d0d0d0",
    position: "relative",
    display: "block",
    lineHeight: 1.3,           // tighter spacing
    minHeight: "38px",         // allow footer to expand naturally
  };

  const linkStyle = {
    color: isDark ? "#a8b3c4" : "#0073bb",
    margin: "0 4px",
    textDecoration: "none",
    fontWeight: 500,
    fontSize: "0.75rem",
  };

  const copyStyle = {
    marginTop: "2px",
    fontSize: "0.7rem",
    opacity: 0.9,
  };

  const disclaimerStyle = {
    marginTop: "3px",
    fontSize: "0.68rem",
    opacity: 0.7,
    maxWidth: "90%",
    marginLeft: "auto",
    marginRight: "auto",
  };

  const links = [
    {
      text:
        language === "hi"
          ? "उपयोग की शर्तें"
          : language === "kn"
          ? "ಬಳಕೆಯ ನಿಯಮಗಳು"
          : "Conditions of Use",
      url: "#",
    },
    {
      text:
        language === "hi"
          ? "गोपनीयता सूचना"
          : language === "kn"
          ? "ಗೌಪ್ಯತಾ ಸೂಚನೆ"
          : "Privacy Notice",
      url: "#",
    },
  ];

  const copyright =
    language === "hi"
      ? "© 2025 नम्मा मेट्रो लाइव | सभी अधिकार सुरक्षित।"
      : language === "kn"
      ? "© 2025 ನಮ್ಮ ಮೆಟ್ರೊ ಲೈವ್ | ಎಲ್ಲಾ ಹಕ್ಕುಗಳು ಕಾಯ್ದಿರಿಸಲಾಗಿದೆ."
      : "© 2025 Sanchaara | All rights reserved.";

  const disclaimer =
    language === "hi"
      ? "यह साइट बेंगलुरु मेट्रो प्रणाली का स्वतंत्र दृश्य-प्रदर्शन है। यह BMRCL या किसी आधिकारिक मेट्रो प्राधिकरण से संबद्ध नहीं है।"
      : language === "kn"
      ? "ಈ ತಾಣವು ಬೆಂಗಳೂರು ಮೆಟ್ರೊ ವ್ಯವಸ್ಥೆಯ ಸ್ವತಂತ್ರ ದೃಶ್ಯೀಕರಣವಾಗಿದೆ. ಇದು BMRCL ಅಥವಾ ಯಾವುದೇ ಅಧಿಕೃತ ಮೆಟ್ರೊ ಪ್ರಾಧಿಕಾರಕ್ಕೆ ಸಂಬಂಧಪಟ್ಟದ್ದಲ್ಲ."
      : "This site is an independent visualization of Bengaluru’s metro system. It is not affiliated with BMRCL or any official metro authority.";

  const [isMobile, setIsMobile] = React.useState(window.innerWidth < 768);

  React.useEffect(() => {
    const handleResize = () => setIsMobile(window.innerWidth < 768);
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  if (isMobile) return null; // keep existing behavior

  return (
    <footer style={containerStyle}>
      <div>
        {links.map((link, index) => (
          <a key={index} href={link.url} style={linkStyle}>
            {link.text}
          </a>
        ))}
      </div>
      <div style={copyStyle}>{copyright}</div>
      <div style={disclaimerStyle}>{disclaimer}</div>
    </footer>
  );
};

export default Footer;
